/**
 * 统计数组中不重复的pointId数量
 * @param analysisItems 分析项目数组
 * @returns 不重复的pointId数量
 */
function countUniquePointIds(analysisItems: any[]): number {
  // 检查输入
  if (!analysisItems || !Array.isArray(analysisItems)) {
    return 0;
  }

  // 使用Set来存储唯一的pointId
  const uniquePointIds = new Set<string | number>();

  // 遍历数组，将每个pointId添加到Set中
  analysisItems.forEach((item) => {
    if (item && item.pointId !== undefined) {
      uniquePointIds.add(item.pointId);
    }
  });

  // 返回Set的大小，即不重复的pointId数量
  return uniquePointIds.size;
}

export default countUniquePointIds;
